import NavBar from "./Navbar.component";
import SubNav from "./SubNav/SubNav.component";

NavBar.SubNav = SubNav;

SubNav.displayName = "NavBar.SubNav";

export default NavBar;
